import { render, staticRenderFns } from "./multymediadetails.vue?vue&type=template&id=48933d0a"
import script from "./multymediadetails.vue?vue&type=script&lang=js"
export * from "./multymediadetails.vue?vue&type=script&lang=js"
import style0 from "./multymediadetails.vue?vue&type=style&index=0&id=48933d0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports